import { createContext } from 'react'

/** What a pinned cell paints over: the surface for a top-level table, the row a nested one sits in. */
export const DataTableBackgroundContext = createContext('figma.grayscale.contentWrapper')
